import { render, staticRenderFns } from "./ResetPasswordMail.vue?vue&type=template&id=59905822&"
import script from "./ResetPasswordMail.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports